<template>
  <div class="mineBox">
    <div class="mineCard">
      <el-card shadow="always">
        <div slot="header" class="header">
          <div class="headerTitle">
            账户余额 {{ handleControlNumber(amount || 0, 2) }}（元）
          </div>
          <div class="headerContent">
            <span class="amount"
            >￥<el-input
                type="number"
                :min="0.11"
                :max="200"
                step="0.01"
                v-model="tixianNum"
                placeholder="单笔限额200元"
                style="width: 220px;"
                @change="changeAmount"
            /></span>
            <span class="txbutton" @click="fullWithdrawal">全部提现</span>
          </div>
        </div>
        <span>提现费率0.6%(最低￥0.01)，当前手续费:￥{{ serviceFee || 0 }}</span>
        <div class="bindWechart">
          <div>
            <img
                src="@/assets/image/svg/weChart.svg"
                alt=""
                style="width: .6944rem;height: .6944rem;"
            />
            <span>提现至微信</span>
          </div>
          <div>
            <span style="color:#444">实时到账：</span>
            <span style="color:#134FC5;font-size: 0.667rem;">¥{{ realAmount || 0 }} </span>
          </div>
        </div>
      </el-card>
      <div class="common-btn-box ">
        <el-button size="medium" class="common-btn-submit2"  @click="tiXian" :disabled="isDisabled">提现</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import "vant/lib/toast/style/index";
import { getMyData, cashWithdrawal, sendMsg, getUserInfo } from "@/api/newApi";
import wx from "weixin-jsapi";
import axios from 'axios';
import {digitUtil} from "@/utils/utils";

export default {
  name: "tixian",
  data() {
    return {
      txShow: false,
      tixianNum: "",
      realAmount: 0,
      serviceFee: 0,
      amount: 0,
      phone: "",
      code: "",
      isdis: true,
      isDisabled: false,
      sendAuthCode: true /*布尔值，通过v-show控制显示‘获取按钮’还是‘倒计时’ */,
      auth_time: 0 /*倒计时 计数器*/,
    };
  },
  methods: {
    handleControlNumber: digitUtil,
    close() {
      this.txShow = false;
    },
    Showtixiandiv() {
      this.txShow = true;
    },
    yanzheng() {
      if (this.phone == "") {
        Toast("请输入手机号");
        return;
      }
      sendMsg({ mobile: this.phone }).then((res) => {
        if (res.message.code != 0) {
          Toast(res.message.message);
        } else {
          Toast(res.message.message);
          this.sendAuthCode = false;
          this.auth_time = 60;
          var auth_timetimer = setInterval(() => {
            this.auth_time--;
            if (this.auth_time <= 0) {
              this.sendAuthCode = true;
              clearInterval(auth_timetimer);
            }
          }, 1000);
        }
      });
    },
    fullWithdrawal(){
      this.tixianNum = this.amount;

      this.changeAmount();
    },
    changeAmount() {
      if(this.tixianNum < 0.11){
        this.tixianNum = 0.11;
      }
      this.serviceFee = parseFloat((this.tixianNum * 0.006).toFixed(2));
      if (this.serviceFee < 0.01) {
        this.serviceFee = 0.01;
      }
      this.realAmount = parseFloat((this.tixianNum - this.serviceFee).toFixed(2));
    },
    tiXian() {
      if (this.tixianNum == "") {
        Toast("请输入提现金额");
        return;
      }else if(this.tixianNum < 0.11){
        Toast("最低提现额为0.11元");
        return;
      }else if(this.tixianNum > this.amount){
        Toast("账户余额不足");
        return;
      }

      // if (this.code == "") {
      //   Toast("请输入验证码");
      //   return;
      // }
      this.isDisabled = true;
      Toast("提现处理中，请稍候...");

      let fullPath = window.location.href;
      console.log("fullPath", fullPath);
      let charArr = fullPath.split('#')
      fullPath = charArr[0];
      console.log("fullPath", fullPath);

      cashWithdrawal({"code": this.code, "amount": this.tixianNum, "url": fullPath}).then((res) => {
        console.log(res);
        if (res.message.code == 0) {

          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.jsSdkSign,// 必填，签名
            jsApiList: ['requestMerchantTransfer'] // 必填，需要使用的JS接口列表
          });

          wx.ready(function () {
            wx.checkJsApi({
              jsApiList: ['requestMerchantTransfer'],
              success: function (wxRes) {
                if (wxRes.checkResult['requestMerchantTransfer']) {
                  WeixinJSBridge.invoke('requestMerchantTransfer', {
                        mchId: res.data.mchId,
                        appId: res.data.appId,
                        package: res.data.package_info,
                      },
                      function (res) {
                        if (res.err_msg === 'requestMerchantTransfer:ok') {
                          Toast("申请提现成功");
                          window.location.reload();
                        }else {
                          Toast(res.errMsg);
                        }

                        this.isDisabled = false;
                      }
                  );
                } else {
                  this.isDisabled = false;
                  Toast('你的微信版本过低，请更新至最新版本。');
                }
              }
            });
          });
          //this.$router.push({ path: "/admin/balance" });
        } else if (res.message.code == -1) {
          if(res.data){
            Toast(res.data);
          }else if(res.message.message){
            Toast(res.message.message);
          }

          this.isDisabled = false;
          //this.$router.push({ path: "/admin/balance" });
        } else {
          Toast({
            message: res.message.message,
            duration: 2000,
          });
          this.isDisabled = false;
        }

      }).catch(() => {
        Toast("申请提现失败，请重试");
        this.isDisabled = false;
      });
    },
  },
  mounted() {
    getMyData().then((res) => {
      if (res.data) {
        this.amount = res.data.amount;
      }
      if (this.amount == 0) {
        this.$emit("tixianUnavailable");
      }
    });
    getUserInfo().then((res) => {
      this.phone = res.data.mobile;
    });
  },
  watch: {
    tixianNum: function(v) {
      if(v == "") {
        return;
      }
      if (v > 200) {
        v = 200;
      }else if (v > this.amount) {
        this.tixianNum = this.amount;
      }
      v = Math.round(v * 100) / 100;
      this.tixianNum = v;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.mineBox {
  padding: 0.2667rem 0.4rem;

  > div {
    margin-bottom: 0.2667rem;
  }

  .mineCard {
    > div {
      margin-bottom: 0.2667rem;
    }
  }

  .header {
    color: #444;

    .headerTitle {
      font-size: 0.32rem;
    }

    .headerContent {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.2778rem;

      .txbutton {
        display: inline-block;
        font-size: 0.3333rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #444;
      }

      > span {
        color: #abb9ec;
      }

      .MyData {
        font-size: 0.6944rem;
      }
    }
  }

  .bindWechart {
    color: #fff;
    font-size: 0.3472rem;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;

    > div:first-child {
      display: flex;
      align-items: center;
    }

    img {
      margin-right: 0.1389rem;
    }
  }
}

.codebutton {
  display: inline-block;
  color: #fff;
  background-color: #134fc5;
  border-radius: 0.1389rem;
  padding: 0.1111rem 0.2778rem;
}

.amount {
  color: #444 !important;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

::v-deep .el-card__header {
  padding: 0 !important;
  margin: 0.2778rem .2778rem 0;
  border-bottom: 1px solid #0e2345;
}

::v-deep .mu-card-header {
  padding: 0.2778rem 0 !important;
}

::v-deep .nut-cell {
  background-color: transparent !important;
}

::v-deep .nut-cell:first-of-type,
::v-deep .nut-cell:last-of-type {
  background-image: none;
}

::v-deep .nut-cell-title {
  color: #666666;
}

.code {
  ::v-deep .el-input__inner {
    text-align: right;
  }

  ::v-deep .el-input__inner::placeholder {
    text-align: right;
  }
}

::v-deep .el-input__inner{
  width: 200px;
}

.common-btn-submit2{
  width: 100%;
  margin-bottom: 0.5333rem;
  height: 1.1733rem;
  line-height: 1.1733rem;
  text-align: center;
  color: #fff;
  font-size: 0.3733rem;
  background: #6d86c4;
  border-radius: 0.5867rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0px solid #5c6e99;
}
</style>

<style type="text/css">
.el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover {
  background-color: #c3c3c3 !important;
  color: #fff!important;
}
</style>